module.exports = __webpack_public_path__ + "imgs/ernest-toney.7fcb61889d268bb1f749af5789a10c48.jpg";